import React from "react";

const InvoicingContext = React.createContext();

export const InvoicingProvider = InvoicingContext.Provider;
export const InvoicingConsumer = InvoicingContext.Consumer;

export default InvoicingContext;